import React, { useState, useEffect } from 'react';
import { auth, db } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc, collection, getDocs } from 'firebase/firestore';

const OperatorLogin = ({ onLogin, onBack }) => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [errorMessage, setErrorMessage] = useState('');
  const [locales, setLocales] = useState([]);
  const [localSeleccionado, setLocalSeleccionado] = useState('');

  useEffect(() => {
    async function cargarLocales() {
      try {
        const snap = await getDocs(collection(db, 'locales'));
        setLocales(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch {
        setLocales([]);
      }
    }
    cargarLocales();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrorMessage('');
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    try {
      const userCredential = await signInWithEmailAndPassword(auth, form.email, form.password);
      const { user } = userCredential;
      const userSnap = await getDoc(doc(db, 'usuarios', user.uid));

      if (!userSnap.exists()) {
        setErrorMessage('No se encontraron datos de usuario.');
        return;
      }

      const profile = userSnap.data();
      if (profile.rol === 'admin') {
        onLogin('adminDashboard', 'admin');
        return;
      }
      if (profile.rol === 'operador') {
        if (!localSeleccionado) {
          setErrorMessage('Seleccioná el local donde estás trabajando.');
          return;
        }
        onLogin('operatorDashboard', 'operator', localSeleccionado);
        return;
      }
      setErrorMessage('Acceso denegado. No sos personal autorizado.');
    } catch (error) {
      setErrorMessage('Email o contraseña incorrectos.');
    }
  };

  const fieldClass =
    'w-full h-12 px-4 rounded-2xl border border-black/10 focus:outline-none focus:ring-2 focus:ring-maja-red bg-white';

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-maja-cream font-sans">
      <div className="hidden lg:block relative">
        <img src="/brand/local-07.jpg" alt="Local Maja Morena" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/45" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <p className="font-display text-4xl">Maja Club</p>
          <p className="font-script text-3xl mt-2">Acceso para personal</p>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-md">
          <img src="/brand/logo-oficial.png" alt="Maja Morena" className="h-16 mx-auto mb-4" />
          <h2 className="text-center font-display text-4xl tracking-tight">Personal</h2>
          <p className="mt-2 text-center text-sm text-maja-ink/60">
            Caja, acreditación de puntos y validación de vouchers
          </p>
          <form className="mt-8 space-y-4" onSubmit={handleLogin}>
            <input
              name="email"
              type="email"
              required
              className={fieldClass}
              placeholder="Email"
              value={form.email}
              onChange={handleChange}
            />
            <input
              name="password"
              type="password"
              required
              className={fieldClass}
              placeholder="Contraseña"
              value={form.password}
              onChange={handleChange}
            />
            <select
              value={localSeleccionado}
              onChange={(e) => setLocalSeleccionado(e.target.value)}
              className={fieldClass}
            >
              <option value="">Local (obligatorio para operadores)</option>
              {locales.map((local) => (
                <option key={local.id} value={local.nombre}>
                  {local.nombre}{local.direccion ? ` — ${local.direccion}` : ''}
                </option>
              ))}
            </select>
            {errorMessage && <p className="text-sm text-maja-red font-semibold">{errorMessage}</p>}
            <button type="submit" className="w-full h-12 rounded-full bg-maja-red text-white font-semibold">
              Ingresar
            </button>
          </form>
          <p className="text-center mt-6">
            <button onClick={onBack} className="text-sm font-semibold text-maja-ink/50 hover:text-maja-red">
              ← Volver a Maja Club
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default OperatorLogin;
